// extracted by mini-css-extract-plugin
module.exports = {"base":"App_base__2C-bG"};